"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.EmbeddedUrlHelper = exports.PARAM_NAME = void 0;
exports.PARAM_NAME = 'cnf';
class EmbeddedUrlHelper {
    constructor(parentLocation) {
        this.parentLocation = parentLocation;
    }
    getKey() {
        return (new URLSearchParams(this.getSearch())).get(exports.PARAM_NAME);
    }
    createLink(configKey) {
        const location = this.getLocation();
        const urlParams = new URLSearchParams(this.getSearch());
        if (configKey === undefined) {
            urlParams.delete(exports.PARAM_NAME);
        }
        else {
            urlParams.set(exports.PARAM_NAME, configKey);
        }
        const search = urlParams.toString();
        const hash = this.getHash();
        return location.origin + location.pathname + (search.length > 0 ? '?' + search : '') + hash;
    }
    getLocation() {
        return this.parentLocation;
    }
    getSearch() {
        const location = this.getLocation();
        return location.search;
    }
    getHash() {
        const location = this.getLocation();
        return location.hash;
    }
}
exports.EmbeddedUrlHelper = EmbeddedUrlHelper;
